export enum FnButtonIconTypes {
  Default = 'default',
  Link = 'link',
  LinkWithIcon = 'linkWithIcon'
}
